import { isUnsubscribePath, markUnsubscribeTab } from './impersonationSession';

// the emailed token, kept in memory only: it never reaches storage, and leaves the address bar before anything loads
let unsubscribeToken = null;

/**
 * Synchronous pre-init, run by unsubscribePreInit.js (the second import of index.js) before i18n, analytics and
 * React. On /unsubscribe it moves `#t=` into memory, strips the fragment from the address bar and history, and marks
 * the tab so analytics is never initialised. A reload therefore finds no token, and the page asks for the email link.
 */
export const consumeUnsubscribeFragment = () => {
    if (!isUnsubscribePath()) {
        return;
    }

    const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    unsubscribeToken = fragment.get('t') || null;
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);

    markUnsubscribeTab();
};

export const getUnsubscribeToken = () => unsubscribeToken;

// test hook: module state survives between tests otherwise
export const resetUnsubscribeLinkState = () => {
    unsubscribeToken = null;
};
